// corpusSources.js — sprint apolo-corpus (CRT1-T04): "código é só mais um corpus".
//
// Registry client-side que unifica as fontes de conhecimento atrás de UM
// contrato — {corpus, path, heading?, title?, chunk, score} — sem mudar o
// comportamento de nada que já existia:
//   · 'vault' → índice semântico LOCAL (IPC apolo:corpus:query; embeddings e
//     vetores nunca saem do Mac — localOnly).
//   · 'code'  → retrieval semântico EXISTENTE da sessão Code (Worker/Vectorize
//     via semanticIndexClient) — apenas ADAPTADO ao contrato, zero mudança.
// O painel "Fontes de Conhecimento" lista daqui; search_brain consulta o
// vault; semantic_search segue intocado.

import { runSemanticSearch } from './semanticIndexClient.js';

function api() {
  return typeof window !== 'undefined' ? window.apolo : null;
}

export function listCorpusSources() {
  const hasLocal = !!api()?.corpus;
  return [
    {
      id: 'vault',
      name: "Pedro's Brain",
      kind: 'obsidian',
      localOnly: true,
      available: hasLocal,
      privacy: 'local · não sai do seu Mac',
    },
    {
      id: 'code',
      name: 'Código (sessão Code)',
      kind: 'code',
      localOnly: false,
      available: true,
      privacy: 'índice da sessão (Vectorize)',
    },
  ];
}

// queryCorpus(id, query, { k, sessionId }) → { ok, results:[{corpus,path,heading,title,chunk,score}], error? }
export async function queryCorpus(id, query, { k = 6, sessionId } = {}) {
  const q = String(query || '').trim();
  if (!q) return { ok: false, error: 'query vazia' };

  if (id === 'vault') {
    const corpus = api()?.corpus;
    if (!corpus?.query) return { ok: false, error: 'índice local indisponível (rode no app Electron)' };
    return corpus.query({ query: q, k });
  }

  if (id === 'code') {
    if (!sessionId) return { ok: false, error: 'corpus code precisa de sessionId' };
    const res = await runSemanticSearch(sessionId, q, { topK: k, useRerank: true });
    if (!res?.ok) return { ok: false, error: res?.error || 'busca semântica falhou' };
    const results = (res.matches || []).map((m) => ({
      corpus: 'code',
      path: m.path || m.file || '',
      heading: m.heading || '',
      title: m.path || m.file || '',
      chunk: m.text || m.chunk || m.snippet || '',
      score: typeof m.score === 'number' ? Math.round(m.score * 10000) / 10000 : 0,
    }));
    return { ok: true, results };
  }

  return { ok: false, error: `corpus desconhecido: ${id}` };
}
